type InputProps = {
    status?: string;
    className?: string;
    inputClassName?: string;
    placeholder?: string;
    icon?: React.ReactNode;
    iconPosition?: "left" | "right";
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    readOnly?: boolean;
    text?: string;
    price?: boolean;
    quantity?: boolean;
    maxLength?: number;
};

const Input = ({
    status,
    className,
    inputClassName,
    placeholder,
    icon,
    iconPosition,
    value,
    onChange,
    readOnly,
    text,
    price,
    quantity,
    maxLength,
}: InputProps) => {
    return (
        <div className={`relative flex items-center ${className}`}>
            {icon && iconPosition === "left" && <span className="absolute left-3 text-gray2">{icon}</span>}
            <input
                disabled={status === "view"}
                maxLength={maxLength}
                placeholder={status === "view" ? "" : placeholder}
                value={value}
                onChange={onChange}
                readOnly={readOnly}
                className={`focus:border focus:border-primary1 placeholder:text-grayicon h-full ${(price||quantity) && "text-end mb-0.5"} ${inputClassName} ${text ? text : "text-sm"} pl-2.5 ${
                    (price||quantity) ? "pr-[22px]" : "pr-2.5"
                } outline-0 rounded-lg py-1.5 pl-${icon && iconPosition === "left" ? "10" : "3"} pr-${
                    icon && iconPosition === "right" ? "10" : "3"
                } ${
                    status === "focused"
                        ? "border border-primary1"
                        : status === "error"
                          ? "border border-error"
                          : status === "none"
                            ? "bg-gray6 !border-none"
                            : status === "view"
                              ? "bg-white border-gray4 border"
                              : "border border-gray4"
                } w-full`}
            />
            {price && <span className="absolute right-4 text-gray2 text-sm">원</span>}
            {quantity && <span className="absolute right-4 text-gray2 text-sm">개</span>}

            {icon && iconPosition === "right" && <span className="absolute right-3 text-gray2">{icon}</span>}
        </div>
    );
};

export default Input;
